<template>
  <b-modal ref="mdlConfigurazioneMagazzinoMultiploArticoli" :title="title" centered no-close-on-backdrop no-close-on-esc hide-header-close size="lg">
    <b-row>
      <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
        <label class="sa-label-data">Codice Azienda</label>
        <span v-if="isReadOnly"> {{ jsonDataMultiploArticolo.codiceAzienda }} </span>
        <b-form-input v-else v-model="jsonDataMultiploArticolo.codiceAzienda"></b-form-input>
      </b-col>
      <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
        <label class="sa-label-data">Multiplo</label>
        <span v-if="isReadOnly"> {{ jsonDataMultiploArticolo.multiploMultiplo }}</span>
        <b-form-input v-else v-model="jsonDataMultiploArticolo.multiplo"></b-form-input>
      </b-col>
      <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
        <label class="sa-label-data">Descrizione Multiplo</label>
        <span v-if="isReadOnly">{{ jsonDataMultiploArticolo.descrizioneMultiplo }}</span>
        <b-textarea v-else v-model="jsonDataMultiploArticolo.descrizioneMultiplo" rows="7" max-rows="10"></b-textarea>
      </b-col>
    </b-row>
    <template #modal-footer>
      <b-button v-if="!isReadOnly" size="md" variant="outline-danger" @click="onCloseModal">Annulla</b-button>
      <b-button v-if="!isReadOnly" size="md" variant="outline-success" @click="onClickSalvaMultiploArticolo">Salva</b-button>
      <b-button v-if="isReadOnly" size="md" variant="outline-secondary" @click="onCloseModal">Chiudi</b-button>
    </template>
    <modal-error ref="cmpModalError"></modal-error>
  </b-modal>
</template>
<script>
import ModalError from "../../../template/components/modal/components/ModalError.vue";
import UtilityMixin from "../../utility/UtilityMixin";
export default {
  mixins: [UtilityMixin],
  components: { ModalError },
  data() {
    return {
      title: null,
      pathResourceMultiploArticoli: "/magazzinoarticolium",
      isReadOnly: false,
      jsonDataMultiploArticolo: {
        id: null,
        codiceAzienda: null,
        multiplo: null,
        descrizioneMultiplo: null,
      },
    };
  },
  mounted() {
    console.log("Componente attivo");
  },
  methods: {
    show(jsonDataMultiploArticolo, isReadOnly) {
      let me = this;
      me.jsonDataMultiploArticolo = jsonDataMultiploArticolo;
      me.isReadOnly = isReadOnly;

      if (isReadOnly) {
        me.title = "Visualizzazione Multiplo";
      } else {
        me.title = !jsonDataMultiploArticolo.id ? "Nuovo Multiplo" : "Aggiorna Multiplo";
      }

      me.$refs.mdlConfigurazioneMagazzinoMultiploArticoli.show();
    },
    onCloseModal() {
      let me = this;
      me.jsonDataMultiploArticolo = {
        id: null,
        codiceAzienda: null,
        multiplo: null,
        descrizioneMultiplo: null,
      };
      me.$emit("onCloseModal");
      me.$refs.mdlConfigurazioneMagazzinoMultiploArticoli.hide();
    },
    onClickSalvaMultiploArticolo() {
      let me = this;
      UtilityMixin.methods.saveResource(me.pathResourceMultiploArticoli, me.jsonDataMultiploArticolo, me.salvaMultiploArticoloSuccess, me.salvaMultiploArticoloError);
    },
    salvaMultiploArticoloSuccess(response) {
      let me = this;
      me.$emit("saveMultiploArticolo", response);
      me.$refs.mdlConfigurazioneMagazzinoMultiploArticoli.hide();
      me.$bvToast.toast("Salvataggio avvenuto con successo", {
        title: "Successo",
        variant: "success",
        solid: true,
      });
    },
    salvaMultiploArticoloError(error) {
      let me = this;
      me.$emit("saveMultiploArticolo", error);
      me.$refs.cmpModalError.show(error.response.data.messaggio);
    },
    onDeleteMultiploArticolo(item) {
      let me = this;
      me.$bvModal
        .msgBoxConfirm("Sei sicuro di eliminare questo multiplo?", {
          title: "Eliminazione Multiplo",
          buttonSize: "sm",
          okTitle: "SI",
          cancelTitle: "NO",
          okVariant: "danger",
          cancelVariant: "secondary",
          hideHeaderClose: true,
          footerClass: "p-2",
          centered: true,
        })
        .then((value) => {
          if (value) {
            me.deleteMultiploArticolo(item.id);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    deleteMultiploArticolo(id) {
      let me = this;
      UtilityMixin.methods.deleteResource(me.pathResourceMultiploArticoli + "/" + id, null, me.deleteMultiploArticoloSuccess, me.deleteMultiploArticoloError);
    },
    deleteMultiploArticoloSuccess(response) {
      let me = this;
      me.$emit("multiploArticoloDelete", response);
      me.$bvToast.toast("Eliminazione avvenuta con successo", {
        title: "Successo",
        variant: "success",
        solid: true,
      });
    },
    deleteMultiploArticoloError(response) {
      let me = this;
      me.$emit("multiploArticoloDelete", response);
      me.$bvToast.toast("Errore durante l'eliminazione", {
        title: "Errore",
        variant: "danger",
        solid: true,
      });
    },
  },
};
</script>
